var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.prefixCls},[_vm._l((_vm.stateTree),function(item,i){return _c('TreeNode',{key:i,attrs:{"data":item,"visible":"","multiple":_vm.multiple,"show-checkbox":_vm.showCheckbox,"children-key":_vm.childrenKey}})}),(!_vm.stateTree.length)?_c('div',{class:[_vm.prefixCls + '-empty']},[_vm._v(_vm._s(_vm.localeEmptyText))]):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }